<template>
  <v-card>
    <v-card-title>
      <span class="headline">New Food</span>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Name*"
                v-model="newFood.name"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-switch label="Frozen?" v-model="newFood.frozen"></v-switch>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Temperature*"
                v-model="newFood.temperature"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Duration*"
                v-model="newFood.duration"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-textarea label="Notes" v-model="newFood.notes"></v-textarea>
            </v-col>
          </v-row>
        </v-container>
        <small>*indicates required fields</small>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="yellow darken-1" text @click="cancel()">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card-text>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: 'CreateFoodCard',
  data() {
    return {
      newFood: {
        name: '',
        duration: '',
        temperature: '',
        notes: '',
        frozen: false,
      },
    };
  },
  methods: {
    save() {
      this.$emit('save', this.newFood)
      this.clearOut()
    },
    cancel() {
      this.clearOut()
      this.$emit('close');
    },
    clearOut() {
      this.newFood.name = '';
      this.newFood.duration = '';
      this.newFood.temperature = '';
      this.newFood.notes = '';
      this.newFood.frozen = false;
    }
  },
};
</script>
